import { MdClose, MdSearch, MdExpandMore, MdArrowForward } from 'react-icons/md';
import DateField from '../common/DateField';

function TrainingJournalFilters({
  filters,
  onFilterChange,
  authors = [],
  isSearching = false,
}) {
  const set = (key, value) => onFilterChange({ ...filters, [key]: value, page: 1 });

  const handleReset = () => onFilterChange({
    search: '', authorId: '', dateFrom: '', dateTo: '', page: 1,
  });

  const anyActive = [filters.search, filters.authorId, filters.dateFrom, filters.dateTo].some(Boolean);

  // Force the shared DateField's trigger to h-10 / rounded-lg so it lines up with the
  // other controls, without touching the clear-× or the popover buttons inside it.
  const dateWrap = 'w-full sm:w-40 [&>div>button:first-child]:h-10 [&>div>button:first-child]:rounded-lg';

  return (
    <div className="bg-card border border-divider rounded-xl px-3 py-3">
      <div className="flex flex-col sm:flex-row sm:flex-wrap sm:items-center gap-2.5">
        {/* Search */}
        <div className="relative w-full sm:flex-1 min-w-0">
          <MdSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-muted pointer-events-none" />
          <input
            type="text"
            value={filters.search || ''}
            onChange={(e) => set('search', e.target.value)}
            placeholder="Search title or content…"
            className="h-10 w-full bg-transparent border border-divider rounded-lg pl-9 pr-8 text-sm text-secondary placeholder:text-subtle focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/30 transition-colors"
          />
          {isSearching && (
            <div className="absolute right-2.5 top-1/2 -translate-y-1/2">
              <div className="w-4 h-4 border-2 border-divider border-t-primary rounded-full animate-spin" />
            </div>
          )}
        </div>

        {/* Author */}
        <div className="relative w-full sm:w-44">
          <select
            value={filters.authorId || ''}
            onChange={(e) => set('authorId', e.target.value)}
            className="h-10 w-full appearance-none bg-card border border-divider rounded-lg pl-3 pr-9 text-sm text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/30 transition-colors"
          >
            <option value="">All authors</option>
            {authors.map((author) => (
              <option key={author._id} value={author._id}>{author.name}</option>
            ))}
          </select>
          <MdExpandMore className="absolute right-2.5 top-1/2 -translate-y-1/2 text-muted text-lg pointer-events-none" />
        </div>

        {/* From date */}
        <div className={dateWrap}>
          <DateField
            label="From date"
            placeholder="From"
            value={filters.dateFrom || ''}
            onChange={(v) => set('dateFrom', v)}
          />
        </div>

        {/* Arrow */}
        <span className="hidden sm:inline-flex items-center text-subtle flex-shrink-0">
          <MdArrowForward className="text-base" />
        </span>

        {/* To date */}
        <div className={dateWrap}>
          <DateField
            label="To date"
            placeholder="To"
            align="right"
            value={filters.dateTo || ''}
            onChange={(v) => set('dateTo', v)}
          />
        </div>

        {/* Clear — only when a filter is active */}
        {anyActive && (
          <button
            onClick={handleReset}
            className="self-end sm:self-auto inline-flex items-center gap-1 h-10 px-2 text-xs font-medium text-muted hover:text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/30 rounded-lg transition-colors flex-shrink-0"
          >
            <MdClose className="text-sm" /> Clear
          </button>
        )}
      </div>
    </div>
  );
}

export default TrainingJournalFilters;
